// Original Code: SlatePlus' Announcement Bar 
const displayCountdownElementNewText = (el) => {
  const text = el.parentElement;
  if (!text) {
    return;
  }

  const onFinishCountdownText = text.getAttribute("data-text-after-countdown");
  if (onFinishCountdownText) {
    el.parentNode.innerHTML = onFinishCountdownText;
  }
};

const displayCountdownTimers = () => {
  const countdowns = document.getElementsByClassName("running-countdown");

  for (const cd of countdowns) {
    const dateStr = cd.getAttribute("data-until-date");
    const timeStr = cd.getAttribute("data-until-time");
    const utc = cd.getAttribute("data-until-utc");

    // const eventTime = moment().tz(`${dateStr}T${timeStr}:00`, "Australia/Sydney");
    // const currentTime = moment().tz();                

    const eventTime = moment(`${dateStr}T${timeStr}:00${utc}`);
    const currentTime = moment();

    let duration = moment.duration(eventTime.diff(currentTime));

    if (duration.days() > 1) {
      cd.innerHTML = duration.days() + " days";
    } else {
      // loop to countdown every 1 second
      const intervalId = setInterval(function () {
        // get updated duration
        duration = moment.duration(duration - 1000, 'milliseconds');
        if (duration.asSeconds() <= 0) {
          clearInterval(intervalId);
          // hide the countdown element
          cd.classList.add("hidden");
          cd && displayCountdownElementNewText(cd);
        } else if (!isNaN(duration.hours())) { // otherwise, show the updated countdown
          const timePart = (p) => String(p).padStart(2, '0')
          cd.innerHTML = timePart(duration.hours()) + ":" + timePart(duration.minutes()) + ":" + timePart(duration.seconds());
        } else {
          console.error(`Duration is invalid ${duration.hours()}`);
          console.error(duration)
        }
      }, 1000);
    }
  }
};

const setLocalStorageWExpiry = (key, value, ttl) => {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

const getLocalStorageItem = (key) => {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
      return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

const displayNonClosedAnnouncementBars = () => {
  const closedStr = getLocalStorageItem("closed-announcements");
  const closed = closedStr ? closedStr : [];
  const bars = document.querySelectorAll("[data-announcement-bar],[data-action-remove-announcement-bar-action]");

  for (const bar of bars) {
    const isClosed = closed.some(c => c == bar.getAttribute("data-text-id"));
    if (!isClosed && bar.classList.contains('hidden')) {
        bar.classList.remove('hidden');
    } else if (isClosed) {
        bar.classList.add('hidden');
    }
  }
}

const listenToCloseAnnouncements = () => {
  const closeButton = document.querySelector("[data-action-remove-announcement-bar-action]");

  closeButton.addEventListener("click", event => {    
    const textsToclose = [...document.querySelectorAll("[data-announcement-bar]")].map(el => el.getAttribute("data-text-id"))
    const closedStr = getLocalStorageItem("closed-announcements");
    const closed = closedStr ? closedStr : [];

    const hoursExpiry = window.announcementCloseExpiry ? window.announcementCloseExpiry : 3;
    const expiryMs = hoursExpiry * 60 * 1000;

    setLocalStorageWExpiry(
      "closed-announcements",
      [...new Set([...closed, ...textsToclose])],
      expiryMs);
    displayNonClosedAnnouncementBars();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  displayCountdownTimers();
  displayNonClosedAnnouncementBars();
  listenToCloseAnnouncements();
});
